export default __webpack_public_path__ + "static/media/icon-menu-question-active.86069c12.svg";